import { Modal } from "react-bootstrap-v5";

const CommonModalTitle = ({ children, onClose }) => (
  <Modal.Header
    closeButton={!!onClose}
    style={{ backgroundColor: "#59AEC6",justifyContent: "center", color: "white" }}
  >
    <Modal.Title className="fw-bold" style={{fontSize:"28px"}}>{children}</Modal.Title>
  </Modal.Header>
);

export default CommonModalTitle;
